import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useFetchPermissions from '../../hooks/fetchPermissions';
import { app } from '../../config';
import { Checkbox, Form, Input, Switch, Col, Row,message,Select } from 'antd';
import getRolePermissionById from '../../hooks/getRolePermissionById';
import { LeftCircleOutlined } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const Edituserpermissions = () => {
  const [editbtn, setEditBtn] = useState('none');
  const [uploadObject, setUploadObject] = useState({});
  const [show, setShow] = useState(false);
  const [rolePermRes, setrolePermRes] = useState({});
  const [checkedList, setCheckedList] = useState([]);
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const token=getTokenfromUserObj();
  let permResp = useFetchPermissions();
  let permissions = permResp.response ? permResp.response.data : [];
  let permLabel = [];
  let orgPermLabel = [];
  let perms = [];
  let roletoGet = JSON.parse(localStorage.getItem('roleId'));
  console.log(roletoGet);
  const rolePermResponse = getRolePermissionById(roletoGet.roleId);
  console.log(rolePermResponse);
  let rolePerm = rolePermResponse.response ? rolePermResponse.response.data : [];
  rolePerm.forEach((ele) => {
    perms.push(ele.permsId);
  });
  console.log(perms);
  if (permissions.length > 0)
    permissions.forEach((ele) => {
      if(ele.permType==='adm') permLabel.push(ele.label);
      else if(ele.permType==='org') orgPermLabel.push(ele.label);
    });
  permLabel = [...new Set(permLabel)];
  orgPermLabel= [...new Set(orgPermLabel)];
  console.log(permLabel);
  const editPerm = (e) => {
    localStorage.setItem('permissionId', JSON.stringify(e.permId));
    navigate('/permission/edit', { replace: true });
  };
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/role/updaterole/${roletoGet.roleId}`, {name:uploadObj.name,roleType:uploadObj.roleType,isActive:uploadObj.isActive},{headers:{auth:token}});
     console.log(res);
      const rolePermRes = await axios.post(`${app.URL}/roleperm/edit`, { rolesId: uploadObj.role,name:uploadObj.name,isActive:uploadObj.isActive, permsId: uploadObj.list },{headers:{auth:token}});
      setrolePermRes(rolePermRes.data);
      setTimeout(()=>{navigate('/role/view')},1000)
    } catch (err) {
      console.log(err);
    }
  };
  let uploadObj = { role: '',name:'',roleType:'',isActive:1, list: [] };
  const onFinish = (values) => {
    console.log('Success:', values);
    uploadObj.name = values.role;
    uploadObj.roleType = values.roleType;
    uploadObj.isActive = values.isActive===true?1:0;
    uploadObj.role = roletoGet.roleId;
    uploadObj.list = checkedList.length < 1 ? perms : checkedList;
    setUploadObject(uploadObj);
    setShow(true);
  };
  const submitData=()=>{
    console.log('calling')  
    console.log(uploadObj)
    if (Object.keys(uploadObject).length > 0 && uploadObject.list.length>0) {
          uploadData(uploadObject);
  }
  else {
    handleClose();
    message.error ("Select atleast one permission")}
}
  const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
  function goBack() {
    navigate('/role/view',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const onChange = (checkedValues) => {
    console.log('checked = ', checkedValues);
    setCheckedList(checkedValues);
  };
  console.log(checkedList);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user.userType === 'A') setEditBtn('block');
  }, []);

  return (
    <div class='tbl mt-3 w-75'>
       <div class="row topbar mt-4" style={{height:"70px",width:"856px"}}>
        <div class='col-lg-4 fs-3 fw-bold'>
        {' '}
        <LeftCircleOutlined onClick={()=>{navigate('/role/view')}} className='mt-3 ml-4 back-icon' style={{ fontSize: '38px'}} />
      </div>
        <div class='col-lg-7 fs-3 fw-bold '>
        <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Role')} </h2>
        </div>
          {' '}
        </div>
        <div class='p-5'>
      {roletoGet ? (
        
        <Form
          class='p-5 mt-8'
          name='basic'
          labelCol={{
            span: 3,
          }}
          wrapperCol={{
            span: 10,
          }}
          // style={{
          //   maxWidth: 600,
          // }}
          initialValues={{
            remember: true,
            ['id']: 1,
            ['role']: roletoGet.roleName,
            ['roleType']:roletoGet.roleType,
            // ['causeCategory']: `${causeCat.length > 0 ? causeCat[0].cause_category : ''}`,
            ['isActive']: roletoGet.isActive === 1 ? true : false,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Form.Item
            colon={false}
            label='Role'
            name='role'
            rules={[
              {
                required: false,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
                  colon={false}
                  label='Role Type'
                  name='roleType'
                  rules={[
                    {
                      required: true,
                      message: 'Select Role Type',
                    },
                  ]}
                >
                  <Select
                    className='custom-select-dropdown'
                    listHeight={250}
                    listItemHeight={500}
                    style={{
                      display: 'block ',
                      width: 220,
                    }}
                    placeholder='Select Role Type'
                  >
                    <Option  className="select-option" value='admin'>Admin</Option>
                    <Option  className="select-option" value='org'>Organization</Option>
                  </Select>
                </Form.Item>
          <Form.Item label='Active' valuePropName='checked' colon={false} name='isActive'>
            <Switch />
          </Form.Item>
          <hr className='fade-effect1 mb-6'/>
          <div className='ml-5'  style={{ width: 780, height: 550, overflowX: 'hidden', overflowY: 'auto', position: 'relative' }}>
          {perms.length > 0 ? (
            <Checkbox.Group
              defaultValue={perms}
              class='pl-6'
              style={{
                width: '100%',
              }}
              onChange={onChange}
            >
    
           <span className='fw-bold fs-5 mt-10' style={{marginBottom:"10px"}}>Admin Permissions</span>
                {permLabel.map((element) => {
                return (
                  <>
                    {
                      <>
                        <h2 class='fw-bold mb-2 mt-3'>{element}</h2>
                        <div>
                        <Row justify='start'>
                          {permissions.map((ele) => {
                            // console.log(ele.permType)
                            if (ele.label === element && ele.permType === 'adm') {
                              // console.log(ele)
                              return (
                                <div >
                                    <Col span={8}> <Checkbox checked={true} value={ele.permId}>
                                  {ele.name}
                                  </Checkbox></Col>
                                    {/* <Col span={4}>col-4</Col>
                                    <Col span={4}>col-4</Col>
                                    <Col span={4}>col-4</Col> */}
                               
                                 
                                </div>
                              );
                            }
                          })}
                           </Row>
                        </div>
                      </>
                    }
                  </>
                );
              })}
                     <hr className='mt-4 mb-3 fade-effect1'/>
              <span className='fw-bold fs-5 mt-5 ' style={{}}>Organization Permissions</span>
               {orgPermLabel.map((element) => {
                return (
                  <>
                    {
                      <>
                        <h2 class='fw-bold mb-2 mt-3'>{element}</h2>
                        <div>
                        <Row justify='start'>
                          {permissions.map((ele) => {
                            // console.log(ele.permType)
                            if (ele.label === element && ele.permType === 'org') {
                              // console.log(ele)
                              return (
                                <div >
                                    <Col span={8}> <Checkbox checked={true} value={ele.permId}>
                                  {ele.name}
                                  </Checkbox></Col>
                                    {/* <Col span={4}>col-4</Col>
                                    <Col span={4}>col-4</Col>
                                    <Col span={4}>col-4</Col> */}
                               
                                 
                                </div>
                              );
                            }
                          })}
                           </Row>
                        </div>
                      </>
                    }
                  </>
                );
              })}
            </Checkbox.Group>
          ) : (
            ' '
          )}
          </div>
          {rolePermRes.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{rolePermRes.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>:rolePermRes.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{rolePermRes.data.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to add Role & Permissions?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={()=>submitData()}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}
          <button className='ml-5' type='primary' class='btn btn-primary button mt-4 ml-5 ' htmlType='submit'>
          Update
          </button>
        </Form>
      ) : (
        ''
      )}
      </div>
    </div>
  );
};

export default Edituserpermissions;
